import React from 'react';
import Box from '@mui/material/Box';
import { ChartContainer } from '@mui/x-charts/ChartContainer';
import { LinePlot } from '@mui/x-charts/LineChart';
import { BarPlot } from '@mui/x-charts/BarChart';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsTooltip } from '@mui/x-charts';

const CombinedBarLineChart = ({
    title = '',
    xData = [],
    xLabel = '',
    barSeries = [], // [{ id, label, data, yAxisId }]
    lineSeries = [], // [{ id, label, data, yAxisId }]
    yAxis = [
        { id: 'bar', position: 'left', width: 65, label: 'Amount' },
        { id: 'line', position: 'right', width: 65, label: 'Count' },
    ],
    height = 320,
}) => {
    // Attach yAxisId if missing
    const barSeriesWithYAxis = barSeries.map(s => ({ ...s, yAxisId: s.yAxisId || 'bar', type: 'bar' }));
    const lineSeriesWithYAxis = lineSeries.map(s => ({ ...s, yAxisId: s.yAxisId || 'line', type: 'line' }));

    const series = [...barSeriesWithYAxis, ...lineSeriesWithYAxis];

    return (
        <div className='line-chart-container'>
            <div className="line-chart">
                <Box sx={{ width: '100%' }}>
                    <ChartContainer
                        xAxis={[
                            {
                                scaleType: 'band',
                                data: xData,
                                id: 'xAxis',
                                label: xLabel,
                                height: 30,
                            },
                        ]}
                        yAxis={yAxis}
                        series={series}
                        height={height}
                    >
                        <BarPlot />
                        <LinePlot />
                        <ChartsXAxis axisId="xAxis" label={xLabel} labelStyle={{ fontSize: 16 }} />
                        {yAxis.map(y => (
                            <ChartsYAxis key={y.id} axisId={y.id} label={y.label} />
                        ))}
                        <ChartsTooltip />
                    </ChartContainer>
                </Box>
            </div>
        </div >
    );
};

export default CombinedBarLineChart;
